import { Query } from 'utility-ts-orm';
import { IQuery } from 'core-ts-types';
import {
  ICourseSearchAuthorizationModel,
  TCourseSearchAuthorizationModel
} from '../models/course_search_authorization_model';

export class CourseSearchAuthorizationQuery implements IQuery {
  private _result: ICourseSearchAuthorizationModel;

  constructor(private ngCourseSearchAuthorizationModel: TCourseSearchAuthorizationModel) {
    Query.registerQuery(this, this.ngCourseSearchAuthorizationModel);
  }

  run() {
    this._result = this.ngCourseSearchAuthorizationModel.read();
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngCourseSearchAuthorizationQuery', CourseSearchAuthorizationQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/queries/course_search_authorization_query.ts